import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './apiClient';
import type { RunIntegrity } from './audit-config-queries';

/** Shape of GET /api/audit/run-status (null before the first recorded run). */
export interface AuditRunStatus {
  lastStatus: 'succeeded' | 'failed';
  lastRunAt: string;
  lastTrigger: 'scheduled' | 'manual';
  lastError: string;
  lastFailureAt: string | null;
  lastSuccessAt: string | null;
  lastSuccessRunId: string | null;
  stale: boolean;
  /** Integrity of the last successful run (null for runs recorded before it existed). */
  integrity?: RunIntegrity | null;
  staleAfterHours: number;
}

export const AUDIT_RUN_STATUS_QUERY_KEY = ['audit', 'run-status'] as const;

/** Polls the latest audit run outcome (every 5 minutes). */
export function useAuditRunStatusQuery() {
  return useQuery({
    queryKey: AUDIT_RUN_STATUS_QUERY_KEY,
    queryFn: () => apiFetch<AuditRunStatus | null>('/api/audit/run-status'),
    refetchInterval: 5 * 60_000,
    staleTime: 60_000,
  });
}
